export default "__VITE_ASSET__Dr7acuwU__"